'use client'

import { PORTAL_TUTORIAL_HIGHLIGHT_PADDING } from '../../const/portal-tutorial-layout.const'
import type { PortalTutorialTargetRect } from '../../interfaces/portal-tutorial-target-rect.interface'

import styles from './PortalTutorial.module.scss'

type PortalTutorialOverlayProps = {
  targetRect: PortalTutorialTargetRect | null
  showHighlight: boolean
}

export function PortalTutorialOverlay({ targetRect, showHighlight }: PortalTutorialOverlayProps) {
  if (!showHighlight || !targetRect) {
    return <div className={styles.overlayPanel} style={{ inset: 0 }} />
  }

  const top = Math.max(0, targetRect.top - PORTAL_TUTORIAL_HIGHLIGHT_PADDING)
  const left = Math.max(0, targetRect.left - PORTAL_TUTORIAL_HIGHLIGHT_PADDING)
  const width = targetRect.width + PORTAL_TUTORIAL_HIGHLIGHT_PADDING * 2
  const height = targetRect.height + PORTAL_TUTORIAL_HIGHLIGHT_PADDING * 2
  const viewportWidth = typeof window !== 'undefined' ? window.innerWidth : 0
  const viewportHeight = typeof window !== 'undefined' ? window.innerHeight : 0

  return (
    <div className={styles.overlayPanels}>
      <div className={styles.overlayPanel} style={{ top: 0, left: 0, right: 0, height: top }} />
      <div className={styles.overlayPanel} style={{ top, left: 0, width: left, height }} />
      <div className={styles.overlayPanel} style={{ top, left: left + width, right: 0, height }} />
      <div className={styles.overlayPanel} style={{ top: top + height, left: 0, right: 0, bottom: 0 }} />
      <div
        className={styles.highlight}
        style={{
          top,
          left,
          width: Math.min(width, viewportWidth - left),
          height: Math.min(height, viewportHeight - top),
        }}
      />
    </div>
  )
}
